module.exports = __webpack_public_path__ + "img/presentation_icon.3ec00c5e.png";